<div class="wrapper-overview">

    <div class="section-title d-flex justify-content-between">
        <div>
            <div class="title">{{'Overview' | translate}}</div>
        </div>
        <div class="create-store topbar-actions">
            <div class="create-btn" [class.disabled]="!canCreateStore" (click)="showCreateStore()">
                <i class="fi fi-rr-plus"></i>
                {{ "Create Store" | translate }}
            </div>
        </div>
    </div>

    <div class="section-main">
        <div class="section-title2 d-flex justify-content-between flex-wrap gap-2">
            <div class="store-name">
                <div class="title">{{ storeName }}</div>
            </div>
            <div class="form-group filter-options">
                <!-- Country Filter Dropdown -->
                <div ngbDropdown class="d-inline-block">
                    <button class="btn btn-filter" id="dropdownBasic2" ngbDropdownToggle>
                        <img *ngIf="countryFlag" class="filter-flag" [src]="countryFlag" alt="">
                        <i *ngIf="!countryFlag" class="fi fi-rr-globe"></i>
                        <span class="hidename">{{ countryName | translate }}</span>
                    </button>
                    <div ngbDropdownMenu aria-labelledby="dropdownBasic2" class="custom-dropdown">
                        <button ngbDropdownItem *ngFor="let country of countryListWithData"
                            [class.active]="country.country_name === countryName"
                            (click)="changeCountry(country.country_code)">
                            <img *ngIf="country.country_flag" class="filter-flag" [src]="country.country_flag" alt="">
                            <span class="fit-width-content">{{ country.country_name | translate }}</span>
                            <i *ngIf="country.country_name === countryName" class="fi fi-rr-check item-check"></i>
                        </button>
                    </div>
                </div>

                <!-- Date Filter Dropdown -->
                <div ngbDropdown class="d-inline-block">
                    <button class="btn btn-filter" id="dropdownBasic1" ngbDropdownToggle>
                        <i class="fi fi-rr-calendar"></i>
                        <span class="hidename">{{ '{0}' | translate:[ utils.translate(dateFilter.type.display )] }}</span>
                    </button>
                    <div ngbDropdownMenu aria-labelledby="dropdownBasic1" class="custom-dropdown">
                        <button ngbDropdownItem *ngFor="let filter of DATE_FILTERS"
                            [class.active]="filter === dateFilter.type"
                            (click)="dateFilter.type = filter; overviewData()">
                            <span class="fit-width-content">{{ '{0}' | translate:[utils.translate(filter.display)] }}</span>
                            <i *ngIf="filter === dateFilter.type" class="fi fi-rr-check item-check"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="row mt-3">
            <div class="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-8">
                <div class="card-nexus mt-xl">
                    <div class="d-flex align-items-center justify-content-between h-100 px-3 py-4">
                        <div class="d-flex align-items-center">
                            <div class="nexus-icon mr-3">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                                    stroke="currentColor" stroke-width="1.75" stroke-linecap="round"
                                    stroke-linejoin="round">
                                    <path d="M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z"></path>
                                    <path d="M4 9h16"></path>
                                    <path d="M9 14l-2 2l2 2"></path>
                                    <path d="M15 14l2 2l-2 2"></path>
                                    <path d="M13 13.5l-2 5"></path>
                                </svg>
                            </div>
                            <div class="nexus-content">
                                <h5 class="nexus-title d-flex align-items-center flex-wrap gap-2">
                                    {{'Build Without Limits: Custom HTML Homepage is Live!' | translate}}
                                    <span class="badge-ai">{{'New Feature' | translate}}</span>
                                </h5>
                                <p class="nexus-subtitle">{{'Take your storefront to the next level! You can now customize and design your dream homepage entirely with your own HTML code.' | translate }}
                                </p>
                            </div>
                        </div>
                        <div class="nexus-action ml-3">
                            <button class="btn btn-nexus-share" routerLink="/dashboard/design">
                                <span>{{'Start Designing Now' | translate}}</span>
                                <i class="fi fi-rr-arrow-small-right ml-1"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-sm-12 col-md-4">
                <div class="card-top mt-xl">
                    <div class="section-icon">
                        <img src="../../../assets/icon/repeatcustomer.svg" alt="Repeat customer">
                    </div>
                    <div class="section-content">
                        <p class="title-white">{{'Repeat Customer' | translate}}</p>
                        <h1 class="title-big">{{repeatCustomer}}</h1>
                    </div>
                    <div class="icon-bg"><img src="../../../assets/icon/repeatcustomer.svg" alt=""></div>
                </div>
            </div>
        </div>

        <!-- Store Setup Sequence Flow -->
        <div class="row mt-4">
            <div class="col-12">
                <div class="card card-sequence-flow">
                    <div class="sequence-glow-bg"></div>

                    <div class="sequence-header d-flex align-items-center justify-content-between flex-wrap gap-3">
                        <div class="header-left d-flex align-items-center gap-3">
                            <div class="flow-hero-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                    <path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z"/>
                                    <path d="m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z"/>
                                    <path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0"/>
                                    <path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5"/>
                                </svg>
                            </div>
                            <div>
                                <div class="flow-pill-tag">{{ 'REVENUE ACCELERATOR' | translate }}</div>
                                <h4 class="sequence-title mb-1">{{ 'Proven Sequence to Boost Your Sales' | translate }}</h4>
                                <p class="sequence-subtitle mb-0">{{ 'Follow this 7-step blueprint to launch high-converting offers, attract buyers, and maximize your revenue' | translate }}</p>
                            </div>
                        </div>
                        <div class="header-right d-flex align-items-center gap-2">
                            <div class="milestone-badge">
                                <span class="pulse-dot"></span>
                                <span class="badge-text">{{ '7 Steps to Scale' | translate }}</span>
                            </div>
                        </div>
                    </div>

                    <!-- Steps Timeline Track -->
                    <div class="sequence-track-wrapper">
                        <div class="sequence-steps-container">
                            <!-- Step 1: Manage your product -->
                            <a class="flow-step-item step-phase-setup" routerLink="/dashboard/product-manager">
                                <div class="step-card-top">
                                    <span class="phase-pill pill-blue">{{ '01' | translate }}</span>
                                    <span class="step-category">{{ 'Catalog' | translate }}</span>
                                </div>
                                <div class="step-icon-wrap icon-blue">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                        <path d="m7.5 4.27 9 5.15"/>
                                        <path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z"/>
                                        <path d="m3.3 7 8.7 5 8.7-5"/>
                                        <path d="M12 22V12"/>
                                    </svg>
                                </div>
                                <div class="step-details">
                                    <h5 class="step-title">{{ 'Manage your product' | translate }}</h5>
                                    <p class="step-desc">{{ 'Edit name, images, descriptions, and quantity settings' | translate }}</p>
                                </div>
                                <div class="step-footer">
                                    <span class="action-label">{{ 'Manage Products' | translate }}</span>
                                    <div class="action-btn-circle">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                                            <line x1="5" y1="12" x2="19" y2="12"></line>
                                            <polyline points="12 5 19 12 12 19"></polyline>
                                        </svg>
                                    </div>
                                </div>
                            </a>

                            <!-- Step 2: Create Express Checkout -->
                            <a class="flow-step-item step-phase-setup" routerLink="/dashboard/express-checkout-create">
                                <div class="step-card-top">
                                    <span class="phase-pill pill-cyan">{{ '02' | translate }}</span>
                                    <span class="step-category">{{ 'Checkout' | translate }}</span>
                                </div>
                                <div class="step-icon-wrap icon-cyan">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                        <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/>
                                        <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/>
                                    </svg>
                                </div>
                                <div class="step-details">
                                    <h5 class="step-title">{{ 'Create Express Checkout' | translate }}</h5>
                                    <p class="step-desc">{{ 'Generate fast Express Checkout links for direct purchases' | translate }}</p>
                                </div>
                                <div class="step-footer">
                                    <span class="action-label">{{ 'Express Checkout' | translate }}</span>
                                    <div class="action-btn-circle">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                                            <line x1="5" y1="12" x2="19" y2="12"></line>
                                            <polyline points="12 5 19 12 12 19"></polyline>
                                        </svg>
                                    </div>
                                </div>
                            </a>

                            <!-- Step 3: Build your landing page -->
                            <a class="flow-step-item step-phase-storefront" routerLink="/dashboard/page/create">
                                <div class="step-card-top">
                                    <span class="phase-pill pill-purple">{{ '03' | translate }}</span>
                                    <span class="step-category">{{ 'Storefront' | translate }}</span>
                                </div>
                                <div class="step-icon-wrap icon-purple">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                        <rect width="18" height="18" x="3" y="3" rx="2"/>
                                        <path d="M3 9h18"/>
                                        <path d="M9 21V9"/>
                                    </svg>
                                </div>
                                <div class="step-details">
                                    <h5 class="step-title">{{ 'Build your landing page' | translate }}</h5>
                                    <p class="step-desc">{{ 'Design responsive, high-converting offer pages' | translate }}</p>
                                </div>
                                <div class="step-footer">
                                    <span class="action-label">{{ 'Design Page' | translate }}</span>
                                    <div class="action-btn-circle">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                                            <line x1="5" y1="12" x2="19" y2="12"></line>
                                            <polyline points="12 5 19 12 12 19"></polyline>
                                        </svg>
                                    </div>
                                </div>
                            </a>

                            <!-- Step 4: Connect your domain -->
                            <a class="flow-step-item step-phase-storefront" routerLink="/dashboard/domain">
                                <div class="step-card-top">
                                    <span class="phase-pill pill-rose">{{ '04' | translate }}</span>
                                    <span class="step-category">{{ 'Domain' | translate }}</span>
                                </div>
                                <div class="step-icon-wrap icon-rose">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                        <circle cx="12" cy="12" r="10"/>
                                        <path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20"/>
                                        <path d="M2 12h20"/>
                                    </svg>
                                </div>
                                <div class="step-details">
                                    <h5 class="step-title">{{ 'Connect your domain' | translate }}</h5>
                                    <p class="step-desc">{{ 'Link your custom web domain for brand trust' | translate }}</p>
                                </div>
                                <div class="step-footer">
                                    <span class="action-label">{{ 'Link Domain' | translate }}</span>
                                    <div class="action-btn-circle">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                                            <line x1="5" y1="12" x2="19" y2="12"></line>
                                            <polyline points="12 5 19 12 12 19"></polyline>
                                        </svg>
                                    </div>
                                </div>
                            </a>

                            <!-- Step 5: Set up tracking -->
                            <a class="flow-step-item step-phase-traffic" routerLink="/dashboard/preferences">
                                <div class="step-card-top">
                                    <span class="phase-pill pill-amber">{{ '05' | translate }}</span>
                                    <span class="step-category">{{ 'Analytics' | translate }}</span>
                                </div>
                                <div class="step-icon-wrap icon-amber">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                        <path d="M12 20v-6M6 20V10M18 20V4"/>
                                        <circle cx="6" cy="7" r="3"/>
                                        <circle cx="12" cy="11" r="3"/>
                                        <circle cx="18" cy="17" r="3"/>
                                    </svg>
                                </div>
                                <div class="step-details">
                                    <h5 class="step-title">{{ 'Set up tracking' | translate }}</h5>
                                    <p class="step-desc">{{ 'Configure pixels and store tracking preferences' | translate }}</p>
                                </div>
                                <div class="step-footer">
                                    <span class="action-label">{{ 'Configure' | translate }}</span>
                                    <div class="action-btn-circle">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                                            <line x1="5" y1="12" x2="19" y2="12"></line>
                                            <polyline points="12 5 19 12 12 19"></polyline>
                                        </svg>
                                    </div>
                                </div>
                            </a>

                            <!-- Step 6: Run ads on Nexus (opens Nexus smart ads via SSO) -->
                            <a class="flow-step-item step-phase-traffic step-featured" href="javascript:void(0)" role="button"
                               [attr.aria-busy]="nexusAdsLoading" (click)="openNexusAds()">
                                <div class="step-card-top">
                                    <span class="phase-pill pill-emerald">{{ '06' | translate }}</span>
                                    <span class="badge-featured">{{ 'New' | translate }}</span>
                                </div>
                                <div class="step-icon-wrap icon-emerald">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                        <path d="m3 11 18-5v12L3 14v-3z"/>
                                        <path d="M11.6 16.8a3 3 0 1 1-5.8-1.6"/>
                                    </svg>
                                </div>
                                <div class="step-details">
                                    <h5 class="step-title">{{ 'Run ads on Nexus' | translate }}</h5>
                                    <p class="step-desc">{{ 'Promote offers and launch automated ad campaigns' | translate }}</p>
                                </div>
                                <div class="step-footer">
                                    <span class="action-label">{{ 'Launch Meta Ads' | translate }}</span>
                                    <div class="action-btn-circle">
                                        <span *ngIf="nexusAdsLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        <svg *ngIf="!nexusAdsLoading" xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                                            <line x1="5" y1="12" x2="19" y2="12"></line>
                                            <polyline points="12 5 19 12 12 19"></polyline>
                                        </svg>
                                    </div>
                                </div>
                            </a>

                            <!-- Step 7: Monitor and report -->
                            <a class="flow-step-item step-phase-scale" routerLink="/dashboard/landing-page-report">
                                <div class="step-card-top">
                                    <span class="phase-pill pill-indigo">{{ '07' | translate }}</span>
                                    <span class="step-category">{{ 'Growth' | translate }}</span>
                                </div>
                                <div class="step-icon-wrap icon-indigo">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                        <path d="M3 3v18h18"/>
                                        <path d="m19 9-5 5-4-4-3 3"/>
                                    </svg>
                                </div>
                                <div class="step-details">
                                    <h5 class="step-title">{{ 'Monitor and report' | translate }}</h5>
                                    <p class="step-desc">{{ 'Track sales performance, conversions, and ROI' | translate }}</p>
                                </div>
                                <div class="step-footer">
                                    <span class="action-label">{{ 'View Reports' | translate }}</span>
                                    <div class="action-btn-circle">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                                            <line x1="5" y1="12" x2="19" y2="12"></line>
                                            <polyline points="12 5 19 12 12 19"></polyline>
                                        </svg>
                                    </div>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row mt-4">
            <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-8">
                <div class="card">
                    <div class="performing-chart">
                        <apx-chart [chart]="apxchart.chart" [dataLabels]="apxchart.dataLabels"
                            [stroke]="apxchart.stroke" [fill]="apxchart.fill" [series]="apxchart.series"
                            [title]="apxchart.title" [colors]="apxchart.colors" [labels]="apxchart.labels"
                            [xaxis]="apxchart.xaxis" [yaxis]="apxchart.yaxis" [legend]="apxchart.legend"
                            [grid]="apxchart.grid" [responsive]="apxchart.responsive" [tooltip]="numFormat">
                        </apx-chart>
                    </div>
                    <div class="section-chart-info d-flex justify-content-end">
                        <div class="row mr-3">
                            <div class="section-text ml-35 row">
                                <div class="dark-blue-circle"></div>
                                <div>
                                    <p class="title">{{ '{0}' | translate:[ utils.translate(dateFilter.type.display )]
                                        }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-4">
                <div class="card card-pie-chart mt-lg">
                    <div class="d-flex justify-content-between">
                        <div>
                            <h5 class="title-black">{{'Sales Chart' | translate}}</h5>
                        </div>
                    </div>
                    <div class="chart">
                        <apx-chart [chart]="sales.chart" [plotOptions]="sales.plotOptions" [series]="sales.series"
                            [labels]="sales.labels" [legend]="sales.legend" [colors]="sales.colors"
                            [dataLabels]="sales.dataLabels" [stroke]="sales.stroke" [responsive]="sales.responsive"
                            [tooltip]="numFormat">
                        </apx-chart>
                    </div>
                    <div class="section-info row">
                        <div class="circle-green"></div>
                        <div class="section-text">
                            <div class="d-flex-column">
                                <h5 class="title">{{currency}} {{global_total_success | number : '1.2-2'}}</h5>
                                <p class="subtitle">{{'Total Success' | translate}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="section-info row">
                        <div class="circle-yellow"></div>
                        <div class="section-text">
                            <div class="d-flex-column">
                                <h5 class="title">{{currency}} {{global_total_pending | number : '1.2-2'}}</h5>
                                <p class="subtitle">{{'Total Pending' | translate}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="section-info row">
                        <div class="circle-red"></div>
                        <div class="section-text">
                            <div class="d-flex-column">
                                <h5 class="title">{{currency}} {{global_total_cancel | number : '1.2-2'}}</h5>
                                <p class="subtitle">{{'Total Cancel' | translate}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>